import { PaletteMode } from "@mui/material";

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = "";

export const DASHBOARD_PATH = "/sample-page";

export interface Config {
  fontFamily: string;
  locale: string;
  presetColor: string;
  navType: PaletteMode | undefined;
  isInWebview: boolean;
}

const config: Config = {
  fontFamily: "source-han-sans-simplified-c",
  navType: "light", // light, dark
  presetColor: "default", // default, theme1, theme2, theme3, theme4, theme5, theme6
  locale: "en", // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
  isInWebview: false
};

export default config;
